module.exports = __webpack_public_path__ + "static/media/view class.9edc8928.svg";